<template>
  <div class="searchbar">
    <!-- <span class="icon">icon</span> -->
    <input type="search" name="search" placeholder="What do you want to learn?" @input="debounceInput" v-model="search">
  </div>
</template>

<script>
import { debounce } from 'lodash'

export default {

  methods: {
    debounceInput: debounce(function () {
      this.$emit('searchStringChanged', this.search)
    }, 500)
  },

  data () {
    return {
      search: ''
    }
  }
}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.searchbar {
  display: flex;
  align-items: center;
  margin: 1rem 0;
  border: 1px solid $color-gray-medium;
  @include text-size-s();

  > input {
    flex: 1;
    padding: 1em;
    border: 0;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Searchbar.vue